import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import store, { RootState } from "../store";

import axios from "axios";
import {
  factoryListApi,
  createFactoryApi,
  updateFactoryApi,
  deleteFactoryApi,
} from "../../api";
import {
  IPFactory,
  IPFactoryListRequest,
  IPCreateFactoryRequest,
  initializeIPFactory,
  IPDeleteFactoryRequest,
} from "../../models/IPFactory";
import { IndeterminateCheckBoxOutlined } from "@material-ui/icons";
import IPConstants from "../../classes/IPConstants";
import { modalCloseAction } from "./interactionReducer";

export const getFactoryList = createAsyncThunk(
  "/factoryList",
  async (params: IPFactoryListRequest, { getState }) => {
    try {
      const requestParams: IPFactoryListRequest = {
        userToken: params.userToken,
        page: params.page,
        rowCount: params.rowCount,
        searchWord: params.searchWord,
      };
      sessionStorage.setItem("factoryListParam", JSON.stringify(requestParams));
      return await axios
        .post(factoryListApi, requestParams)
        .then((res) => res.data);
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);
export const createFactory = createAsyncThunk(
  "/createFactory",
  async (params: IPCreateFactoryRequest, { getState, dispatch }) => {
    console.log(getState);
    try {
      const requestParams: IPCreateFactoryRequest = {
        userToken: params.userToken,
        item: params.item,
      };
      return await axios
        .post(createFactoryApi, requestParams)
        .then((res) => res.data)
        .then(data => {
          if (data.message.indexOf(IPConstants.successMessage) > -1) {
            const param = JSON.parse(sessionStorage.getItem("factoryListParam")!);
            dispatch(getFactoryList(param));
            dispatch(modalCloseAction());
          }
        });
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);

// note 2022-02-03 SmokingScully가 추가
export const updateFactory = createAsyncThunk(
  "/updateFactory",
  async (params: IPCreateFactoryRequest, { getState, dispatch }) => {
    console.log(getState);
    try {
      const requestParams: IPCreateFactoryRequest = {
        userToken: params.userToken,
        item: params.item,
      };
      return await axios
        .post(updateFactoryApi, requestParams)
        .then((res) => res.data).then(data => {
          if (data.message.indexOf(IPConstants.successMessage) > -1) {
            const param = JSON.parse(sessionStorage.getItem("factoryListParam")!);
            dispatch(getFactoryList(param));
            dispatch(modalCloseAction());
          }
        });
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);

// note 2022-02-03 SmokingScully가 추가
export const deleteFactory = createAsyncThunk(
  "/deleteFactory",
  async (params: IPDeleteFactoryRequest, { getState, dispatch }) => {
    console.log(getState);
    try {
      const requestParams: IPDeleteFactoryRequest = {
        userToken: params.userToken,
        id: params.id,
      };
      return await axios
        .post(deleteFactoryApi, requestParams)
        .then((res) => res.data)
        .then(data => {
          if (data.message.indexOf(IPConstants.successMessage) > -1) {
            const param = JSON.parse(sessionStorage.getItem("factoryListParam")!);
            dispatch(getFactoryList(param));
          }
        });
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);

interface factoryList {
  loading: boolean;
  factoryList: IPFactory[];
  selectFactory: IPFactory;
  currentFactory: IPFactory;
  factoryEditSwitch: boolean;
  error: string;
  maxPage: number;
  message: string;
  currentUid: number | null;
  tableHeader: string[];
}

const initialState: factoryList = {
  loading: true,
  factoryList: [] as IPFactory[],
  selectFactory: {} as IPFactory,
  currentFactory: {} as IPFactory,
  factoryEditSwitch: false,
  error: "",
  maxPage: 0,
  message: "",
  currentUid: null,
  tableHeader: [
    "#",
    "UID",
    "공장명",
    "공장 이니셜",
    "비고",
    "로고",
    "등록인",
    "등록날짜",
    "수정날짜",
    "편집",
  ],
};

const factoryListSlice = createSlice({
  name: "factoryList",
  initialState,
  reducers: {
    currentFactoryAction: (state, { payload }: PayloadAction<IPFactory>) => {
      state.selectFactory = payload;
    },
    modifyFactoryAction: (state) => {
      state.currentFactory = state.selectFactory;
      state.factoryEditSwitch = true;
    },
    createFactoryAction: (state) => {
      state.currentFactory = initializeIPFactory;
      state.factoryEditSwitch = false;
    },

    deleteFactoryAction: (
      state,
      { payload }: PayloadAction<number | null>
    ): void => {
      const deleteFactory = state.factoryList?.filter(
        (factory) => factory.uid !== payload
      );
      state.factoryList = [...deleteFactory];
    },
    currentUidAction: (state, { payload }: PayloadAction<number>): void => {
      state.currentUid = payload;
    },
    searchingFactoryAction: (state, { payload }: PayloadAction<string>) => {
      const searching = state.factoryList?.filter((factory) =>
        factory.name.toLowerCase().trim().includes(payload.toLowerCase().trim())
      );
      state.factoryList = searching;
    },
  },
  extraReducers: {
    [getFactoryList.pending.type]: (state) => {
      state.loading = true;
    },
    [getFactoryList.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.factoryList = action.payload.items;
      state.maxPage = action.payload.maxPage;
      state.message = action.payload.message;
    },
    [getFactoryList.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },
    [createFactory.pending.type]: (state) => {
      state.loading = true;
    },
    [createFactory.fulfilled.type]: (state, action) => {
      state.loading = false;
      // state.factoryList.push(action.payload.item);

    },
    [createFactory.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

    [updateFactory.pending.type]: (state) => {
      state.loading = true;
    },
    [updateFactory.fulfilled.type]: (state, action) => {
      state.loading = false;
      // const index = state.factoryList.findIndex(
      //   (x) => x.uid === action.payload.item.uid
      // );
      // if (index > -1) state.factoryList[index] = action.payload.item;
    },
    [updateFactory.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

    [deleteFactory.pending.type]: (state) => {
      state.loading = true;
    },
    [deleteFactory.fulfilled.type]: (state, action) => {
      console.log(action.payload);
      state.loading = false;
      // const deleteFactory = state.factoryList?.filter(
      //   (factory) => factory.uid !== action.payload.id
      // );
      // state.factoryList = deleteFactory;
    },
    [deleteFactory.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },
  },
});

export const {
  currentFactoryAction,
  createFactoryAction,
  modifyFactoryAction,
  deleteFactoryAction,
  searchingFactoryAction,
  currentUidAction,
} = factoryListSlice.actions;

export default factoryListSlice.reducer;
